import {
  deleteAksiPerubahan,
  getDashboardAksiPerubahan,
  getDetailAksiPerubahan,
  getListAksiPerubahan,
  importAksiPerubahan,
  postAksiPerubahan,
  postJenisKategori,
  updateAksiPerubahan,
} from '@crema/services/apis/aksiPerubahan';
import {
  DELETE_AKSI_PERUBAHAN,
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  GET_AKSI_PERUBAHAN,
  GET_DASHBOARD_AKSI_PERUBAHAN,
  GET_DETAIL_AKSI_PERUBAHAN,
  IMPORT_AKSI_PERUBAHAN,
  POST_AKSI_PERUBAHAN,
  SHOW_MESSAGE,
} from 'shared/constants/ActionTypes';

export const onGetListAksiPerubahan = (query = '', page = 0, ext = '') => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    getListAksiPerubahan(query, page, ext)
      .then((res) => {
        if (res) {
          dispatch({type: FETCH_SUCCESS});
          dispatch({type: GET_AKSI_PERUBAHAN, payload: res});
        } else {
          dispatch({type: FETCH_ERROR, payload: res});
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onGetDetailAksiPerubahan = (id) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    getDetailAksiPerubahan(id)
      .then((res) => {
        if (res) {
          dispatch({type: FETCH_SUCCESS});
          dispatch({type: GET_DETAIL_AKSI_PERUBAHAN, payload: res.results});
        } else {
          dispatch({type: FETCH_ERROR, payload: res});
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onGetDashboardAksiPerubahan = (id) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    getDashboardAksiPerubahan(id)
      .then((res) => {
        if (res) {
          dispatch({type: GET_DASHBOARD_AKSI_PERUBAHAN, payload: res.results});

          dispatch({type: FETCH_SUCCESS});
        } else {
          dispatch({type: FETCH_ERROR, payload: res});
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onPostAksiPerubahan = (payload, file) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    postAksiPerubahan(payload, file)
      .then((res) => {
        if (res) {
          if (res.success) {
            dispatch({
              type: SHOW_MESSAGE,
              payload: 'Berhasil Menambah Aksi Perubahan!',
            });
            dispatch({type: POST_AKSI_PERUBAHAN, payload: res});
          } else
            dispatch({
              type: FETCH_ERROR,
              payload: res.results?.non_field_errors || res?.results?.error,
            });
        } else {
          dispatch({type: FETCH_ERROR, payload: res});
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onFilterLaporanAksiPerubahan = (payload) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    postFilterLaporanAksiPerubahan(payload)
      .then((res) => {
        if (res) {
          dispatch({
            type: FETCH_SUCCESS,
            payload: 'Berhasil Menambah Aksi Perubahan!',
          });
          dispatch({type: POST_AKSI_PERUBAHAN, payload: res});
        } else {
          dispatch({type: FETCH_ERROR, payload: res});
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onPostJenisKategori = (payload) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    postJenisKategori(payload)
      .then((res) => {
        if (res) {
          if (res.success) {
            dispatch({
              type: SHOW_MESSAGE,
              payload: 'Berhasil Menambah Jenis Kategori!',
            });
            dispatch({type: POST_AKSI_PERUBAHAN, payload: res});
          } else
            dispatch({
              type: FETCH_ERROR,
              payload: res.results.non_field_errors,
            });
        } else {
          dispatch({type: FETCH_ERROR, payload: res});
        }})
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onUpdateAksiPerubahan = (id, payload, file) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    updateAksiPerubahan(id, payload, file)
      .then((res) => {
        if (res) {
          if (res.success) {
            dispatch({
              type: SHOW_MESSAGE,
              payload: 'Berhasil Mengubah Aksi Perubahan!',
            });
            dispatch({type: POST_AKSI_PERUBAHAN, payload: res});
          } else
            dispatch({
              type: FETCH_ERROR,
              payload: res.results.non_field_errors,
            });
        } else {
          dispatch({type: FETCH_ERROR, payload: "Terjadi Kesalahan !"});
        }})
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onDeleteAksiPerubahan = (id) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    deleteAksiPerubahan(id)
      .then((res) => {
        if (res) {
          dispatch({
            type: FETCH_SUCCESS,
            payload: 'Berhasil Menghapus Aksi Perubahan!',
          });
          dispatch({type: DELETE_AKSI_PERUBAHAN});
        } else {
          dispatch({type: FETCH_ERROR, payload: res});
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const onImportAksiPerubahan = (file) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    importAksiPerubahan(file)
      .then((res) => {
        if (res) {
          dispatch({
            type: FETCH_SUCCESS,
            payload: 'Berhasil Import Aksi Perubahan!',
          });
          dispatch({type: IMPORT_AKSI_PERUBAHAN});
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'File yang di upload tidak sesuai format!',
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: 'File yang di upload tidak sesuai format!',
        });
      });
  };
};
